import { useGLTF } from "@react-three/drei"
import { useContext, useRef } from "react"

import modelUrl from "../../assets/model.glb"
import AppContext from "../../hooks/AppConext"
import { Annotations } from "../Annotations"
import { SmartBounds } from "../Helpers/SmartBounds"
import { BG } from "./BG"
import { MuseumComplex } from "./MuseumComplex"

export const Complex = ({ ...props }) => {
  const group = useRef()
  const { nodes } = useGLTF(modelUrl)

  const { selected, menuHovered } = useContext(AppContext)
  const condition = selected && (menuHovered === selected || !menuHovered)

  return (
    <group ref={group} {...props}>
      {condition && <Annotations />}
      <SmartBounds>
        <MuseumComplex nodes={nodes} />
      </SmartBounds>
      <BG nodes={nodes} />
    </group>
  )
}

useGLTF.preload(modelUrl)
